import { Box, Typography, Paper, Button, makeStyles } from "@material-ui/core";
import { useTranslate } from "react-admin";
const useConfirmStyles = makeStyles((theme) => {
  return {
    allContainer: {
      margin: "0 auto",
      width: 581,
      height: 489,
      marginTop: 13,
      backgroundColor: "#ebebeb",
    },
    header: {
      marginTop: 56,
    },
    row: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginLeft: 122,
      marginTop: 8,
    },
    firstRow: {
      paddingTop: 33,
    },
    otherRow: {
      marginTop: 9,
    },
    topic: {},
    description: {
      marginLeft: 40,
    },
    button: {
      width: 253,
      height: 58,
      backgroundColor: theme.potentialBlue,
    },
    buttonContainer: {
      margin: "0 auto",
      width: 581,
      marginTop: 31,
      display: "flex",
      justifyContent: "space-between",
    },
    buttonLabelPrimary: theme.buttonLabelPrimary,
    buttonLabelSecondary: theme.buttonLabelSecondary,
  };
});
const ConfirmationView = ({ registerData, onClickEdit, onConfirm }) => {
  const {
    firstname,
    lastname,

    nickname,

    phone,
    gender,
    email,
    birthdate,
    occupation,
    nationality,
    state,
    address,
    recommended_by,
    invite_code,
  } = registerData;

  const classes = useConfirmStyles();
  const translate = useTranslate();
  const fullName = `${firstname} ${lastname} ${
    nickname || nickname !== "" ? `(${nickname})` : ""
  }`;

  return (
    <Box>
      <Typography variant="h6" align="center" className={classes.header}>
        {translate("ra.text.inputInformation.customerInfoSummary")}
      </Typography>
      <Paper className={classes.allContainer}>
        <Box className={[classes.row, classes.firstRow]}>
          <Typography className={classes.topic} variant="subtitle2">
            {translate("ra.text.inputInformation.fullName")}
          </Typography>
          <Box className={classes.description} variant="body2">
            <Typography>{fullName}</Typography>
          </Box>
        </Box>

        <ConfirmTextComponent
          label={translate("ra.text.inputInformation.phoneNumber")}
          className={classes.row}
        >
          {phone}
        </ConfirmTextComponent>
        <ConfirmTextComponent
          label={translate("ra.text.inputInformation.emailAddress")}
          className={classes.row}
        >
          {email}
        </ConfirmTextComponent>
        <ConfirmTextComponent
          label={translate("ra.text.inputInformation.birthday")}
          className={classes.row}
        >
          {birthdate}
        </ConfirmTextComponent>
        <ConfirmTextComponent
          label={translate("ra.text.inputInformation.occupation")}
          className={classes.row}
        >
          {occupation}
        </ConfirmTextComponent>
        <ConfirmTextComponent
          label={translate("ra.text.inputInformation.nationality")}
          className={classes.row}
        >
          {nationality}
        </ConfirmTextComponent>
        {gender ? (
          <ConfirmTextComponent
            label={translate("ra.text.inputInformation.gender")}
            className={classes.row}
          >
            {gender}
          </ConfirmTextComponent>
        ) : null}
        <ConfirmTextComponent
          label={translate("ra.text.inputInformation.martialStatus")}
          className={classes.row}
        >
          {state}
        </ConfirmTextComponent>
        <ConfirmTextComponent
          label={translate("ra.text.inputInformation.address")}
          className={classes.row}
        >
          {address}
        </ConfirmTextComponent>
        <ConfirmTextComponent label="Recommended By" className={classes.row}>
          {recommended_by}
        </ConfirmTextComponent>
        <ConfirmTextComponent label="Referral code" className={classes.row}>
          {invite_code}
        </ConfirmTextComponent>
      </Paper>
      <Box className={classes.buttonContainer}>
        <Button
          className={classes.button}
          variant="contained"
          color="secondary"
          onClick={onClickEdit}
        >
          <Typography className={classes.buttonLabelSecondary}>
            {" "}
            {translate("ra.action.edit")}
          </Typography>
        </Button>
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          onClick={onConfirm}
        >
          <Typography className={classes.buttonLabelPrimary}>
            {translate("ra.action.confirm")}
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

const useConfirmTextStyles = makeStyles((theme) => ({
  description: {
    marginLeft: 40,
  },
}));
const ConfirmTextComponent = ({ className, label, children }) => {
  const classes = useConfirmTextStyles();
  if (!children) return null;
  return (
    <Box className={className}>
      <Typography variant="subtitle2">{label}</Typography>
      <Typography className={classes.description}>{children}</Typography>
    </Box>
  );
};

export default ConfirmationView;
